    <template>
        <div v-if="skeletonloading">
            <Skeleton height="2.5rem" width="23%" class="my-4" />
            <Skeleton height="2.5rem" width="33%" class="my-4" />

            <div class="d-flex flex-wrap gap-5">
                <Skeleton height="2.5rem" width="30%" v-for="items in 20" />
            </div>
            <div class="d-flex flex-wrap justify-content-end gap-5">
                <Skeleton height="2.5rem" width="13%" class="my-4" />
                <Skeleton height="2.5rem" width="13%" class="my-4" />
            </div>
        </div>
    </template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    props: {
        skeletonloading: {
            type: Boolean,
            default: false,
        }
    }
})
</script>



<style scoped>
.loader-container {
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    opacity: 0.6;
    height: 100%;
    position: absolute;
    z-index: 100;
}

.Loadergif {
    height: 200px;
}



@media screen and (max-width: 2560px) and (min-width: 1400px) {
    .Loadergif {
        top: 400px;
    }

    .Loadergif {
        height: 150px;
    }
}

@media only screen and (max-width:545px) {
    .Loadergif {
        top: 130px;
    }
}
</style>
